import queryString from 'query-string';
import React, { useContext } from 'react';
import { useQuery } from 'react-query';
import { useHistory, useLocation } from 'react-router-dom';
import { BASE_URL } from 'shared/constants/AppConst';
import AppContextPropsType from 'types/AppContextPropsType';

import purchaseAPI from '@healthme/services/api/purchases/Index';
import cartService from '@healthme/services/cart/index';
import patientService from '@healthme/services/patient/index';
import AppContext from '@healthme/utility/AppContext';

import { cacheApi2 } from '../../../utility/Utils';

export default function Initializer() {
	const pathArr = window.location.pathname
		.replace('/v1', '')
		.split('/')
		.filter(e => e.length);
	const orgSlug = pathArr[0].toLowerCase();
	const marketplaceSlug = pathArr[1]?.toLowerCase();
	const history = useHistory();

	const location = useLocation();
	const qs = queryString.parse(location.search);
	const { updatePrimaryColor, updateImageLogo, setPageLoading } =
		useContext<AppContextPropsType>(AppContext);
	React.useEffect(() => {
		setPageLoading(true);
	}, []);

	useQuery(
		`organization:${orgSlug}`,
		() => {
			if (orgSlug !== 'paylink') {
				return cacheApi2(`public/organizations/${orgSlug}`, {}, orgSlug);
			}
			return Promise.resolve(null);
		},
		{
			onSuccess: data => {
				console.log('we should not be here');
				patientService.setPatientOrganization(data);
				localStorage.setItem('orgSlug', orgSlug);
				if (!marketplaceSlug || marketplaceSlug === 'paylink') {
					sessionStorage.clear();

					let queryParams = {
						organization_id: data.id,
					};

					cacheApi2(
						`public/marketplaces`,
						{ queryParams },
						`initializer-${data.id}`
					).then(resp => {
						if (resp.data.length) {
							if (marketplaceSlug === 'paylink') {
								const marketplace = resp.data[0];
								const qs = queryString.parse(location.search);
								const paylink = qs?.t;
								purchaseAPI
									.getRaw(`paylinks/token`, {
										queryParams: { t: paylink },
									})
									.then(resp => {
										console.log('paylink', paylink);
										console.log('token response', resp);
										if (typeof resp === 'string') {
											setPageLoading(false);
											window.location.href = `/v1/${orgSlug}/${marketplace.name_slug}/expired`;
											return;
										}
										localStorage.setItem(
											'paylinkPayload',
											JSON.stringify(resp)
										);
										localStorage.setItem(
											'marketplaceSlug',
											marketplace.name_slug
										);
										cartService.clear();
										window.location.href = `/v1/index.html?redirectUrl=${encodeURIComponent(
											`${orgSlug}/${marketplace.name_slug}/checkout`
										)}&t=${paylink}`;
									})
									.catch(e => {
										window.location.href = `/v1/index.html?redirectUrl=${encodeURIComponent(
											`${orgSlug}/404`
										)}`;
									});
								return;
							}
						}
						console.log('resp.data[0].name_slug', resp.data[0].name_slug);
						window.location.href = `/v1/index.html?redirectUrl=${encodeURIComponent(
							`${orgSlug}/${resp.data[0].name_slug}`
						)}`;
						return;
					});
				}
				if (marketplaceSlug) {
					let key = `initializer-${marketplaceSlug}`;
					cacheApi2(`public/marketplaces/${marketplaceSlug}`, {}, key).then(
						marketplace => {
							if (typeof marketplace === 'string' || marketplace?.error) {
								return;
							}
							if (updatePrimaryColor)
								updatePrimaryColor(
									'#' + marketplace?.primary_color.replace('#', '')
								);
							if (updateImageLogo && marketplace?.image_path)
								updateImageLogo(`${BASE_URL}/${marketplace?.image_path}`);
							patientService.set(
								'marketplaces',
								JSON.stringify(marketplace),
								'marketplace'
							);
							localStorage.setItem('marketplaceSlug', marketplaceSlug);
							patientService.setPatientMarketplace(marketplace);
							setPageLoading(false);
						}
					);
				}
			},
		}
	);
	// Handle paylink URL processing
	React.useEffect(() => {
		const handlePaylink = async () => {
			if (window.location.pathname.includes('/paylink') && qs.org) {
				try {
					localStorage.setItem('paylink', qs.token);
					localStorage.setItem('orgSlug', qs.org);
					const paylinkData = await purchaseAPI.getRaw(`paylinks/token`, {
						queryParams: { t: qs.token },
					});
					console.log('paylink data is string', typeof paylinkData === 'string');
					if (typeof paylinkData === 'string') {
						const orgResponse = await purchaseAPI.getRaw(
							`public/organizations/${qs.org}`
						);
						const marketplaceResp = await purchaseAPI.getRaw(`public/marketplaces`, {
							queryParams: {
								organization_id: orgResponse.id,
							},
						});
						const marketplace = marketplaceResp.data[0];
						console.log('paylink data', paylinkData);
						window.location.href = `/v1/${qs.org}/${marketplace.name_slug}/expired`;
						return;
					}
					const marketplaceResp = await purchaseAPI.getRaw(`public/marketplaces`, {
						queryParams: {
							organization_id: paylinkData.organization_id,
						},
					});
					const marketplace = marketplaceResp.data[0];
					localStorage.setItem('paylinkPayload', JSON.stringify(paylinkData));
					localStorage.setItem('marketplaceSlug', marketplace.name_slug);
					history.push(
						`/${paylinkData.organization.name_slug}/${marketplace.name_slug}/checkout?t=${qs.token}`
					);
				} catch (error) {
					console.error('Error processing paylink:', error);
				}
			}
		};

		handlePaylink();
	}, [qs.org, qs.token, history]);

	return <></>;
}
